import { createI18n } from 'vue-i18n'

type PersistedAppStorage = {
  app?: {
    langInfo?: string
  }
}

let lang: string | undefined
const raw = localStorage.getItem('CiaoCameraApp')
const localStorageInfo: PersistedAppStorage | null = raw ? JSON.parse(raw) : null
if (localStorageInfo && localStorageInfo.app) {
  lang = localStorageInfo.app.langInfo
}

function loadLocaleMessages() {
  const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages: Record<string, unknown> = {}
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const i18n = createI18n({
  legacy: false,
  locale: lang || process.env.VUE_APP_I18N_LOCALE || 'ja',
  fallbackLocale: lang || process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ja',
  // require.context で読み込む JSON は vue-i18n の厳格な LocaleMessages 型と合わないため
  messages: loadLocaleMessages() as never,
  globalInjection: true,
  warnHtmlInMessage: 'off',
})

// 呼び出し側（const/app 等）で I18n ジェネリクスが深くなりすぎるため、
// 旧 shim（any）相当の互換を保つ
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default i18n as any
